// /a/:companyCode/:assetCode — the address printed in every asset QR (brief fix #2). Signed-in members of that
// account land on the asset; anyone else learns it is not theirs. (Signed-out visitors sign in first.)
import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { Navigate, useParams } from 'react-router';
import { useSession } from '../auth/session';
import { Empty, Loading, Page } from '../components/Page';
import { supabase } from '../lib/supabase';

export function LabelLinkPage() {
  const { t } = useTranslation();
  const { companyCode = '', assetCode = '' } = useParams();
  const { me } = useSession();
  const mine = !!me?.company && me.company.code.toUpperCase() === companyCode.toUpperCase();
  const asset = useQuery({
    queryKey: ['label-link', companyCode, assetCode],
    enabled: mine || !!me?.platform_admin,
    queryFn: async () => {
      let q = supabase()
        .from('assets')
        .select('id, companies!inner(code)')
        .eq('asset_code', assetCode);
      q = q.eq('companies.code', companyCode.toUpperCase());
      const { data, error } = await q.limit(1);
      if (error) throw new Error(error.message);
      return (data?.[0] as { id: string } | undefined) ?? null;
    },
  });

  if (!mine && !me?.platform_admin) {
    return (
      <Page title={assetCode}>
        <Empty>{t('labels.other_account')}</Empty>
      </Page>
    );
  }
  if (asset.isLoading) return <Loading />;
  if (asset.data) return <Navigate to={`/assets/${asset.data.id}`} replace />;
  return (
    <Page title={assetCode}>
      <Empty>{t('labels.not_found')}</Empty>
    </Page>
  );
}
